import { FaLifeRing } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "../../containers/help/helpContactDetails";

const InstallationStateSupportSection = ({ cameraId, emailSubjectKey }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const supportMailSubject = encodeURIComponent(
    t(emailSubjectKey, { cameraId }),
  );
  const supportMailHref = `mailto:${SUPPORT_EMAIL}?subject=${supportMailSubject}`;

  return (
    <section className="installation-subpage-card installation-state-support-card">
      <span className="installation-battery-guide-icon installation-state-support-icon">
        <FaLifeRing aria-hidden />
      </span>
      <h2 className="installation-subpage-card-title">
        {t("installation_state_support_card_title")}
      </h2>
      <p className="installation-subpage-card-text">
        {t("installation_state_support_card_body")}
      </p>
      <a href={supportMailHref} className="installation-state-support-button">
        {t("installation_state_network_contact_support")}
      </a>
      <button
        type="button"
        className="installation-state-support-link-button"
        onClick={() => history.push("/app/help")}
      >
        {t("installation_state_network_open_help_center")}
      </button>
    </section>
  );
};

export default InstallationStateSupportSection;
